var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-video",
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true,
        },
        on: {
          showEdit: _vm.initCurrentData,
          storeEdit: _vm.storeBlock,
          closeEdit: _vm.initCurrentData,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _vm.currentTitle !== "" && _vm.currentURL
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-block-title",
                        },
                        [_vm._v(_vm._s(_vm.currentTitle))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentURL
                    ? _c("video", {
                        attrs: {
                          src: _vm.currentURL,
                          type:
                            _vm.currentFile !== ""
                              ? _vm.currentFile.mime_type
                              : "",
                          controls: "",
                          autoplay: _vm.currentAutoplay === "enabled",
                        },
                        on: {
                          contextmenu: _vm.contextHandler,
                        },
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "courseware-tabs",
                        [
                          _c(
                            "courseware-tab",
                            {
                              attrs: {
                                index: 0,
                                name: _vm.$gettext("Grunddaten"),
                                selected: true,
                              },
                            },
                            [
                              _c(
                                "form",
                                {
                                  staticClass: "default",
                                  on: {
                                    submit: function submit($event) {
                                      $event.preventDefault()
                                    },
                                  },
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$gettext("Überschrift")) +
                                        "\n                            "
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.currentTitle,
                                          expression: "currentTitle",
                                        },
                                      ],
                                      attrs: {
                                        type: "text",
                                      },
                                      domProps: {
                                        value: _vm.currentTitle,
                                      },
                                      on: {
                                        input: function input($event) {
                                          if ($event.target.composing) return
                                          _vm.currentTitle = $event.target.value
                                        },
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("label", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$gettext("Quelle")) +
                                        "\n                            "
                                    ),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.currentSource,
                                            expression: "currentSource",
                                          },
                                        ],
                                        on: {
                                          change: function change($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.currentSource = $event.target
                                              .multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "studip",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$gettext("Dateibereich")
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "web",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$gettext("Web-Adresse")
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.currentSource === "web",
                                          expression: "currentSource === 'web'",
                                        },
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.$gettext("URL")) +
                                          "\n                            "
                                      ),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.currentWebUrl,
                                            expression: "currentWebUrl",
                                          },
                                        ],
                                        attrs: {
                                          type: "text",
                                        },
                                        domProps: {
                                          value: _vm.currentWebUrl,
                                        },
                                        on: {
                                          input: function input($event) {
                                            if ($event.target.composing) return
                                            _vm.currentWebUrl =
                                              $event.target.value
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.currentSource === "studip",
                                          expression:
                                            "currentSource === 'studip'",
                                        },
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.$gettext("Datei")) +
                                          "\n                            "
                                      ),
                                      _c("studip-file-chooser", {
                                        attrs: {
                                          selectable: "file",
                                          courseId: _vm.context.id,
                                          userId: _vm.userId,
                                          isVideo: true,
                                          excludedCourseFolderTypes:
                                            _vm.excludedCourseFolderTypes,
                                        },
                                        model: {
                                          value: _vm.currentFileId,
                                          callback: function callback($$v) {
                                            _vm.currentFileId = $$v
                                          },
                                          expression: "currentFileId",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "courseware-tab",
                            {
                              attrs: {
                                index: 1,
                                name: _vm.$gettext("Video Einstellungen"),
                              },
                            },
                            [
                              _c(
                                "form",
                                {
                                  staticClass: "default",
                                  on: {
                                    submit: function submit($event) {
                                      $event.preventDefault()
                                    },
                                  },
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$gettext("Seitenverhältnis")
                                        ) +
                                        "\n                            "
                                    ),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.currentAspect,
                                            expression: "currentAspect",
                                          },
                                        ],
                                        on: {
                                          change: function change($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.currentAspect = $event.target
                                              .multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "169",
                                            },
                                          },
                                          [_vm._v("16:9")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "43",
                                            },
                                          },
                                          [_vm._v("4:3")]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("label", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$gettext(
                                            "Video startet automatisch"
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.currentAutoplay,
                                            expression: "currentAutoplay",
                                          },
                                        ],
                                        on: {
                                          change: function change($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.currentAutoplay = $event.target
                                              .multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "disabled",
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$gettext("Nein")))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "enabled",
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$gettext("Ja")))]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("label", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$gettext("Contextmenü")) +
                                        "\n                            "
                                    ),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.currentContextMenu,
                                            expression: "currentContextMenu",
                                          },
                                        ],
                                        on: {
                                          change: function change($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.currentContextMenu = $event
                                              .target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "enabled",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$gettext("Erlauben"))
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "disabled",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$gettext("Verhindern"))
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _vm._v(_vm._s(_vm.$gettext("Informationen zum Video-Block"))),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }